<div *ngIf="isHeaderAllowed$ | async" class="gradient-title-block">
  <div class="container">
    <h1 class="display-3 m-0">TripMaker - Beta</h1>
  </div>
</div>
<div class="container">
  <div class="row">
    <router-outlet></router-outlet>
  </div>
</div>
